module.exports = __webpack_public_path__ + "img/banner.753e088.jpeg";